import AwaitedDialog from "./components/awaitedDialog";
import AwaitedDrawer from "./components/awaitedDrawer";
import AwaitedMenu from "./components/awaitedMenu";
export var AwaitedModals = {
    'Dialog': AwaitedDialog,
    'Drawer': AwaitedDrawer,
    'Menu': AwaitedMenu
};
